// extracted by mini-css-extract-plugin
export default {"container":"src-feature-customer-list-__batch-options_container","drawerPaper":"src-feature-customer-list-__batch-options_drawerPaper"};